export default __webpack_public_path__ + "static/media/discord.250e9b2e.svg";